import { SingleTrimSpec } from '../../../../services/vehicle-data-service/vehicle-data-service.types';
import './dyf-vehicle-specs.scss';

interface VehicleSpecProps {
    specs: SingleTrimSpec[] | null;
}

export const DyfVehicleSpecs = (props: VehicleSpecProps) => {
    if (props.specs) {
        return (
            <div
                className="vehicle-specs-wrap"
                data-testid="vehicle-specs-wrap"
            >
                <ul>
                    {props.specs.map(spec => (
                        <li key={spec.wersCode}>{spec.shortDescription}</li>
                    ))}
                </ul>
            </div>
        );
    } else {
        return <></>;
    }
};
